module.exports = __webpack_public_path__ + "img/Offer.6f39a7dc.svg";